module.exports = __webpack_public_path__ + "img/40_01_009_618.8e424e70.jpg";